module.exports = __webpack_public_path__ + "img/ico-calendar-next.9e28d994.svg";